import { useLocation } from "react-router-dom";

const EMAIL_LOGIN_TAB_INDEX = 0;
const PIN_LOGIN_TAB_INDEX = 1;

interface UseLoginTabLogicProps {
  returnUrl?: string;
}

export const useLoginTabLogic = ({ returnUrl }: UseLoginTabLogicProps = {}) => {
  const location = useLocation();

  const getTargetReturnUrl = (): string | null => {
    const searchParams = new URLSearchParams(location.search);
    const urlReturnUrl = searchParams.get("returnUrl");
    return returnUrl || urlReturnUrl;
  };

  const isPublicRoute = (): boolean => {
    const targetReturnUrl = getTargetReturnUrl();

    if (targetReturnUrl) {
      const decodedReturnUrl = decodeURIComponent(targetReturnUrl);
      return decodedReturnUrl.includes('/public/');
    }

    return false;
  };

  const determineActiveTab = (): number => {
    return isPublicRoute() ? PIN_LOGIN_TAB_INDEX : EMAIL_LOGIN_TAB_INDEX;
  };

  const shouldShowPinTab = (): boolean => {
    return isPublicRoute();
  };

  return {
    determineActiveTab,
    shouldShowPinTab,
    EMAIL_LOGIN_TAB_INDEX,
    PIN_LOGIN_TAB_INDEX,
  };
};
